<script lang="ts" setup>
import { ref } from "vue";

import ViSelect from "@/components/elements/vi-select/vi-select.vue";
import ViBarChart from "@/components/elements/vi-charts/bar/vi-bar-chart.vue";
import ViRatingBar from "@/components/elements/vi-rating-bar/vi-rating-bar.vue";

const selectedCompany = ref("a87dfga");
const companiesList = ref([
  {
    uid: "a87dfga",
    value: "a87dfga",
    label: "Pixelmatters",
  },
]);
const stats = ref([
  {
    title: "Impact Rating",
    valueLabel: "AAA",
    value: undefined,
  },
  {
    title: "Impact Score",
    valueLabel: "35",
    value: 35,
  },
  {
    title: "Positive Impact",
    valueLabel: "+40",
    value: 40,
  },
  {
    title: "Negative Impact",
    valueLabel: "-5",
    value: -5,
  },
]);

const data = ref({
  labels: ["SDG 3: Health", "SDG 8: Economey & Jobs", "SDG 9: Infrastructure"],
  datasets: [
    {
      data: [50, 35, 20],
      backgroundColor: ["#4C9F38", "#A21942", "#FD6925"],
    },
  ],
});
const options = ref({
  scales: {
    y: {
      min: 0,
      max: 100,
    },
  },
});
</script>

<template>
  <div class="sdg-dashboard-by-sdg">
    <div class="header">
      <div class="header-title">Pixelmatters</div>
      <div class="header-list">
        <span>SELECT COMPANY</span>
        <ViSelect :options="companiesList" :selected-option="selectedCompany" />
      </div>
    </div>
    <div class="stats">
      <div v-for="stat of stats" :key="stat.value" class="stat-card">
        <span class="stat-card__title">{{ stat.title }}</span>
        <div class="stat-card__stat">
          <span class="stat-card__stat-value">
            {{ stat.valueLabel }}
          </span>
          <ViRatingBar
            v-if="typeof stat.value === 'number'"
            :value="stat.value"
          />
        </div>
      </div>
    </div>
    <div class="chart">
      <div class="chart__header">
        <span class="chart__title">Top positively impacted SDGs</span>
        <span class="chart__link">How impact is measured</span>
      </div>
      <ViBarChart :data="data" :scales="options.scales" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.sdg-dashboard-by-sdg {
  padding: 32px;

  .header {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }

  .header-title {
    color: var(--color-text);
    font-size: var(--text-xl);
    font-weight: var(--font-semibold);
  }

  .header-list {
    gap: 8px;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-end;

    span {
      display: block;
      white-space: nowrap;
      font-size: var(--text-sm);
      color: var(--color-text);
      font-weight: var(--font-semibold);
    }
  }

  .stats {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 32px;
    gap: 24px;
  }

  .stat-card {
    background-color: #fafafa;
    border: 1px solid #f0f1f5;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.15);
    width: 25%;
    padding: 20px;
    border-radius: 4px;

    &__title {
      color: var(--color-text-light);
      font-size: var(--text-base);
      font-weight: var(--font-semibold);
    }

    &__stat {
      margin-top: 8px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }

    &__stat-value {
      font-weight: var(--font-semibold);
      font-size: var(--text-3xl);
    }

    :deep(.vi-rating-bar) {
      width: 100px;
    }
  }

  .chart {
    width: 100%;
    min-height: 400px;
    margin-top: 24px;
    padding: 24px;
    box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.1);
    border-radius: 8px;

    &__header {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;
    }

    &__title {
      color: var(--color-text);
      font-size: var(--text-xl);
      font-weight: var(--font-medium);
    }
  }
}
</style>
